/* Abbeya London — theme behaviour (lightweight, dependency-free) */
(function () {
  'use strict';

  // Sticky header shadow on scroll
  var header = document.querySelector('[data-site-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-stuck', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Mobile navigation drawer
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  function setDrawer(open) {
    if (!drawer) return;
    drawer.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
  }
  if (openBtn) openBtn.addEventListener('click', function () { setDrawer(true); });
  document.querySelectorAll('[data-drawer-close]').forEach(function (el) {
    el.addEventListener('click', function () { setDrawer(false); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') setDrawer(false);
  });

  // Rotating announcement messages
  document.querySelectorAll('[data-announcement]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announcement__item');
    if (items.length < 2) return;
    var speed = (parseInt(bar.getAttribute('data-rotate'), 10) || 5) * 1000;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, speed);
  });
})();

/* =========================================================================
   PRODUCT PAGE — gallery, variant picker, quantity, accordions, share,
   sticky ATC, recommendations, recently viewed. Dependency-free.
   ========================================================================= */
(function () {
  'use strict';

  // ---- Gallery thumbnails ----
  document.querySelectorAll('[data-gallery]').forEach(function (scope) {
    var main = scope.querySelector('.product__main-img');
    var thumbs = scope.querySelectorAll('[data-thumb]');
    if (!main || !thumbs.length) return;
    function activate(thumb) {
      thumbs.forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var full = thumb.getAttribute('data-full');
      if (full) { main.removeAttribute('srcset'); main.removeAttribute('sizes'); main.src = full; }
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { activate(t); }); });
    scope._activateMediaId = function (id) {
      var t = scope.querySelector('[data-thumb][data-media-id="' + id + '"]');
      if (t) activate(t);
    };
  });

  // ---- Accordions ----
  document.querySelectorAll('[data-accordion]').forEach(function (acc) {
    var head = acc.querySelector('[data-accordion-head]');
    var body = acc.querySelector('[data-accordion-body]');
    if (!head || !body) return;
    function set(open) {
      acc.classList.toggle('is-open', open);
      head.setAttribute('aria-expanded', open ? 'true' : 'false');
      body.style.maxHeight = open ? body.scrollHeight + 'px' : '0px';
    }
    if (acc.classList.contains('is-open')) requestAnimationFrame(function () { set(true); });
    head.addEventListener('click', function () { set(!acc.classList.contains('is-open')); });
  });

  // ---- Quantity steppers ----
  document.querySelectorAll('[data-qty]').forEach(function (q) {
    var input = q.querySelector('[data-qty-input]');
    var minus = q.querySelector('[data-qty-minus]');
    var plus = q.querySelector('[data-qty-plus]');
    if (minus) minus.addEventListener('click', function () { input.value = Math.max(1, (parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { input.value = (parseInt(input.value, 10) || 1) + 1; });
  });

  // ---- Share ----
  document.querySelectorAll('[data-share]').forEach(function (sh) {
    var url = window.location.href.split('?')[0];
    var title = document.title;
    var set = function (sel, href) { var el = sh.querySelector(sel); if (el) el.href = href; };
    set('[data-share-x]', 'https://twitter.com/intent/tweet?url=' + encodeURIComponent(url) + '&text=' + encodeURIComponent(title));
    set('[data-share-fb]', 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url));
    set('[data-share-wa]', 'https://api.whatsapp.com/send?text=' + encodeURIComponent(title + ' ' + url));
    set('[data-share-mail]', 'mailto:?subject=' + encodeURIComponent(title) + '&body=' + encodeURIComponent(url));
    var nativeBtn = sh.querySelector('[data-share-native]');
    if (nativeBtn) {
      if (navigator.share) { nativeBtn.addEventListener('click', function () { navigator.share({ title: title, url: url }).catch(function () {}); }); }
      else { nativeBtn.style.display = 'none'; }
    }
    var copyBtn = sh.querySelector('[data-share-copy]');
    if (copyBtn) copyBtn.addEventListener('click', function () {
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () {
        copyBtn.classList.add('is-copied'); setTimeout(function () { copyBtn.classList.remove('is-copied'); }, 1500);
      });
    });
  });

  // ---- Variant picker ----
  var root = document.querySelector('[data-product-info]');
  if (root) {
    var json = root.querySelector('[data-variant-json]');
    var variants = [];
    try { variants = JSON.parse(json.textContent); } catch (e) {}
    var gallery = root.querySelector('[data-gallery]');
    var priceEl = root.querySelector('[data-price]');
    var compareEl = root.querySelector('[data-compare]');
    var saveEl = root.querySelector('[data-save]');
    var stock = root.querySelector('[data-stock]');
    var stockLabel = root.querySelector('[data-stock-label]');
    var lowThreshold = stock ? (parseInt(stock.getAttribute('data-low'), 10) || 10) : 10;
    var inText = stock ? stock.getAttribute('data-in-text') : 'In stock';
    var atc = root.querySelector('[data-atc]');
    var atcLabel = root.querySelector('[data-atc-label]');
    var atcDefault = atcLabel ? atcLabel.textContent : 'Add to Cart';
    var stickyPrice = document.querySelector('[data-sticky-price]');
    var stickyBtn = document.querySelector('[data-sticky-atc-btn]');
    var stickyLabel = document.querySelector('[data-sticky-atc-label]');
    var idInputs = root.querySelectorAll('[data-variant-id]');
    var selectors = root.querySelectorAll('[data-option-selector]');

    function current() {
      var chosen = [];
      root.querySelectorAll('.variant-option').forEach(function (opt) {
        var sel = opt.querySelector('[data-option-selector]:checked');
        if (sel) chosen.push(sel.value);
      });
      if (!chosen.length) return variants[0];
      return variants.find(function (v) {
        return v.options.length === chosen.length && v.options.every(function (o, i) { return o === chosen[i]; });
      });
    }

    function update() {
      var v = current();
      if (!v) return;
      idInputs.forEach(function (i) { i.value = v.id; });
      if (priceEl) priceEl.textContent = v.price_formatted;
      if (stickyPrice) stickyPrice.textContent = v.price_formatted;
      if (compareEl) { if (v.compare_formatted) { compareEl.textContent = v.compare_formatted; compareEl.hidden = false; } else { compareEl.hidden = true; } }
      if (saveEl) { if (v.save_formatted) { saveEl.textContent = 'Save ' + v.save_formatted; saveEl.hidden = false; } else { saveEl.hidden = true; } }

      var avail = v.available;
      if (atc) atc.disabled = !avail;
      if (stickyBtn) stickyBtn.disabled = !avail;
      if (atcLabel) atcLabel.textContent = avail ? atcDefault : 'Sold Out';
      if (stickyLabel) stickyLabel.textContent = avail ? 'Add to Cart' : 'Sold Out';

      if (stock && stockLabel) {
        stock.classList.remove('is-in', 'is-low', 'is-out');
        if (!avail) { stock.classList.add('is-out'); stockLabel.textContent = 'Sold out'; }
        else if (v.managed && v.inv > 0 && v.inv <= lowThreshold) { stock.classList.add('is-low'); stockLabel.textContent = 'Low stock — only ' + v.inv + ' left'; }
        else { stock.classList.add('is-in'); stockLabel.textContent = inText; }
      }

      // selected-value label per option
      root.querySelectorAll('.variant-option').forEach(function (opt) {
        var sel = opt.querySelector('[data-option-selector]:checked');
        var lbl = opt.querySelector('[data-option-selected]');
        if (sel && lbl) lbl.textContent = sel.value;
      });

      if (v.media_id && gallery && gallery._activateMediaId) gallery._activateMediaId(v.media_id);

      if (history.replaceState) {
        try { var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      }
    }

    selectors.forEach(function (s) { s.addEventListener('change', update); });
  }

  // ---- Sticky ATC visibility (mobile) ----
  var stickyBar = document.querySelector('[data-sticky-atc]');
  var mainAtc = document.querySelector('[data-atc]');
  if (stickyBar && mainAtc && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        stickyBar.classList.toggle('is-visible', !e.isIntersecting && e.boundingClientRect.top < 0);
      });
    });
    io.observe(mainAtc);
  }

  // ---- Product recommendations (related / complementary) ----
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        var url = this.getAttribute('data-url');
        if (!url || this.querySelector('.products__grid')) return;
        var self = this;
        fetch(url).then(function (r) { return r.text(); }).then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var el = doc.querySelector('product-recommendations');
          if (el && el.innerHTML.trim()) { self.innerHTML = el.innerHTML; }
          else { self.hidden = true; }
        }).catch(function () { self.hidden = true; });
      }
    });
  }

  // ---- Recently viewed ----
  (function () {
    var KEY = 'abbeya_recently_viewed';
    var cur = window.AbbeyaProduct || null;
    var list = [];
    try { list = JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) {}
    if (cur && cur.handle) {
      list = list.filter(function (p) { return p.handle !== cur.handle; });
      list.unshift(cur);
      list = list.slice(0, 8);
      try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    }
    var section = document.querySelector('[data-recently-viewed]');
    if (!section) return;
    var grid = section.querySelector('[data-recently-grid]');
    var items = list.filter(function (p) { return !cur || p.handle !== cur.handle; }).slice(0, 4);
    if (!items.length) return;
    function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }
    var ph = '<div class="ph"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="4" width="18" height="16" rx="1.5"/><circle cx="8.5" cy="9.5" r="1.6"/><path d="M21 16l-5-5-7 7"/></svg><span>Product image</span></div>';
    items.forEach(function (p) {
      var media = p.image ? '<img src="' + esc(p.image) + '" alt="' + esc(p.title) + '" loading="lazy">' : ph;
      grid.insertAdjacentHTML('beforeend',
        '<div class="product-card" data-testid="recently-viewed-card">' +
          '<a class="product-card__media" href="' + esc(p.url) + '">' + media + '</a>' +
          '<a class="product-card__name" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<span class="product-card__price">' + esc(p.price) + '</span>' +
        '</div>');
    });
    section.hidden = false;
  })();
})();

/* =========================================================================
   COLLECTION PAGE — sort/filter auto-submit + mobile filter drawer
   ========================================================================= */
(function () {
  'use strict';

  // Auto-submit sort form on change
  document.querySelectorAll('[data-sort-form] select').forEach(function (s) {
    s.addEventListener('change', function () { if (s.form) s.form.submit(); });
  });

  // Auto-submit filters on change
  var ff = document.querySelector('[data-filter-form]');
  if (ff) {
    ff.querySelectorAll('[data-filter-input]').forEach(function (i) {
      i.addEventListener('change', function () { ff.submit(); });
    });
  }

  // Mobile filter drawer
  var panel = document.querySelector('[data-filters-panel]');
  var overlay = document.querySelector('.collection__filters-overlay');
  function setF(open) {
    if (panel) panel.classList.toggle('is-open', open);
    if (overlay) overlay.classList.toggle('is-open', open);
    document.body.classList.toggle('no-scroll', open);
  }
  document.querySelectorAll('[data-filter-open]').forEach(function (b) { b.addEventListener('click', function () { setF(true); }); });
  document.querySelectorAll('[data-filter-close]').forEach(function (b) { b.addEventListener('click', function () { setF(false); }); });
})();

/* =========================================================================
   SEARCH MODAL (predictive) + LOCALIZATION auto-submit
   ========================================================================= */
(function () {
  'use strict';

  // Localization country select auto-submit
  document.querySelectorAll('[data-locale-select]').forEach(function (s) {
    s.addEventListener('change', function () { if (s.form) s.form.submit(); });
  });

  var modal = document.querySelector('[data-search-modal]');
  if (!modal) return;
  var input = modal.querySelector('[data-search-input]');
  var results = modal.querySelector('[data-search-results]');
  var suggestUrl = modal.getAttribute('data-suggest-url');
  var searchUrl = modal.getAttribute('data-search-url');

  function open() {
    modal.hidden = false;
    document.body.classList.add('no-scroll');
    requestAnimationFrame(function () { modal.classList.add('is-open'); if (input) input.focus(); });
  }
  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { modal.hidden = true; }, 320);
  }

  // Bind the header search icon(s) — progressive enhancement
  document.querySelectorAll('a[aria-label="Search"], summary[aria-label="Search"], .header__icon--search').forEach(function (el) {
    el.addEventListener('click', function (e) { e.preventDefault(); open(); });
  });
  modal.querySelectorAll('[data-search-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && !modal.hidden) close(); });

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function render(data, q) {
    var r = (data.resources && data.resources.results) || {};
    var products = r.products || [];
    var queries = r.queries || [];
    var html = '';
    if (products.length) {
      html += '<div class="search-sugg__group"><span class="search-sugg__head">Products</span>';
      products.forEach(function (p) {
        var src = (p.featured_image && p.featured_image.url) || p.image || '';
        var img = src ? '<img src="' + esc(src) + '" alt="" loading="lazy">' : '';
        html += '<a class="search-sugg__item" href="' + esc(p.url) + '">' +
          '<span class="search-sugg__thumb">' + img + '</span>' +
          '<span class="search-sugg__info"><span class="search-sugg__title">' + esc(p.title) + '</span>' +
          (p.price ? '<span class="search-sugg__price">' + esc(p.price) + '</span>' : '') +
          '</span></a>';
      });
      html += '</div>';
    }
    if (queries.length) {
      html += '<div class="search-sugg__group"><span class="search-sugg__head">Suggestions</span>';
      queries.forEach(function (qq) { html += '<a class="search-sugg__query" href="' + esc(qq.url) + '">' + esc(qq.text) + '</a>'; });
      html += '</div>';
    }
    if (!products.length && !queries.length) {
      html = '<div class="search-sugg__group"><span class="search-sugg__query">No matches yet. Press Enter to search.</span></div>';
    } else {
      html += '<a class="search-sugg__all" href="' + esc(searchUrl + '?q=' + encodeURIComponent(q)) + '">View all results</a>';
    }
    results.innerHTML = html;
  }

  var timer;
  if (input) input.addEventListener('input', function () {
    clearTimeout(timer);
    var q = input.value.trim();
    if (q.length < 2) { results.innerHTML = ''; return; }
    timer = setTimeout(function () {
      fetch(suggestUrl + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product,collection,query&resources[limit]=6&resources[options][unavailable_products]=last')
        .then(function (r) { return r.json(); })
        .then(function (d) { render(d, q); })
        .catch(function () {});
    }, 250);
  });
})();
